export default "__VITE_ASSET__BIUMGmtb__"